import React, { useContext } from "react";
import { HubContext } from "Redux/Context/context";
import RegisteredActivityListItem from "./Registered";
import PublishedActivityListItem from "./Published";
import FavoriteActivityListItem from "./Favorite";

function ActivityListItem({ activity }) {
  const { myActivitiesState } = useContext(HubContext);
  return (
    <>
      {myActivitiesState.module === "REGISTERED" && (
        <RegisteredActivityListItem activity={activity} />
      )}
      {myActivitiesState.module === "PUBLISHED" && (
        <PublishedActivityListItem activity={activity} />
      )}
      {myActivitiesState.module === "FAVORITE" && (
        <FavoriteActivityListItem activity={activity} />
      )}
    </>
  );
}

export default ActivityListItem;
